/**
 * Phone helpers — pure utilities, no DB calls.
 * Used by the VoIP screen pop (PSA-54) and anywhere caller IDs are normalised.
 */

/** Strip every non-digit character. */
function digitsOnly(raw: string): string {
  return (raw ?? "").replace(/\D+/g, "");
}

/**
 * Normalise any phone string to E.164 (+1XXXXXXXXXX for US/CA).
 * Returns null if the input cannot be resolved to a valid number.
 */
export function toE164(raw: string, defaultCountry = "1"): string | null {
  if (!raw) return null;
  const d = digitsOnly(raw);
  if (!d) return null;
  if (d.length === 11 && d.startsWith("1")) return `+1${d.slice(1)}`;
  if (d.length === 10) return `+${defaultCountry}${d}`;
  return null;
}

/** Strip non-digits and return the last 10 digits (fuzzy matching / display). */
export function last10(raw: string): string {
  const d = digitsOnly(raw);
  return d.length > 10 ? d.slice(-10) : d;
}

/** Format an E.164 number for display: +19048147752 → (904) 814-7752 */
export function formatPhone(e164: string): string {
  if (!e164) return "";
  const ten = last10(e164);
  if (ten.length !== 10) return e164;
  return `(${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`;
}
